import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e8f5544"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "How about the Blog | Zetreex", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "description",
  content: "Zetreex, Software Development Company - These are our valuable blog!"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:url",
  content: "https://zetreex.com/blog/:id"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:title",
  content: "How about the Blog | Zetreex"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("link", {
  rel: "canonical",
  href: "https://zetreex.com/blog/:id"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:description",
  content: "Zetreex, Software Development Company - These are our valuable blog!"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "url",
  content: "https://zetreex.com/blog/:id"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Head = _resolveComponent("Head")!
  const _component_soft_item = _resolveComponent("soft-item")!
  const _component_feed_back = _resolveComponent("feed-back")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Head, null, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7
      ]),
      _: 1
    }),
    _createVNode(_component_soft_item, {
      loading: _ctx.loading,
      item: _ctx.blogs,
      isProjects: false
    }, null, 8, ["loading", "item"]),
    _createVNode(_component_feed_back)
  ], 64))
}